import { FC, useEffect, useState } from 'react'
import { getProductType } from '../../services/ContentServices';
import { ModuleComponent, ModuleComponents } from '../../types/ContentStructure';
import { Box } from '@mui/material';
import ComponentType from '../../components/component_type/ComponentType';
import { slugify } from '../../utils/utils';

interface ProductTypePageProps {
    product_type: string
}
const ProductTypePage: FC<ProductTypePageProps> = ({ product_type }) => {
    const [productType, setProductType] = useState<ModuleComponents>();

    useEffect(() => {
        const fetchData = async () => {
            const response = await getProductType(slugify(product_type!));
            setProductType(response.data);
        }
        fetchData();
    }, [])
    if (!productType) {
        return <></>
    }
    return (

        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
        }}>
            <Box sx={{
                maxWidth: '1920px',
                display: 'flex',
                width: '100%',
                minHeight: '100vh',
                flexDirection: 'column',
                gap: 2,
            }}>
                {
                    productType.components.map((item: ModuleComponent, idx: number) => {
                        return <ComponentType key={idx} component={item.component} />
                    })
                }
            </Box>
        </Box>
    )
}

export default ProductTypePage
